import aiContentProjectAgent from 'common/src/modules/aiContent/copilot/agents/aiContentProjectAgent/aiContentProjectAgent';
import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';
import aiContentProjectSkill from 'common/src/modules/shared/copilot/skills/definitions/aiContentProjectSkill';
import {registerSkill} from 'common/src/modules/shared/copilot/skills/skillRegistry';
import {CLStore} from 'common/src/redux/store';
import {copilot} from '@cl/shared';

function initializeAiContentAgents(store: CLStore) {
  if (isFlagEnabled(FeatureFlagKey.EnableCopilotAiContentProjectAgent)) {
    if (!isFlagEnabled(FeatureFlagKey.EnableCopilotSkills)) {
      copilot.registerAgent(aiContentProjectAgent(store));
    }

    registerSkill(aiContentProjectSkill(store));
  }
}

export default initializeAiContentAgents;
